export const widthHideSidebars = 1179;
export const desktopMinWidth = 910;
export const appTopPadding = 104;
export const appTopPaddingMobile = 80;